import styled from 'styled-components';
import themeData from 'utils/theme/themeData';

const { typography } = themeData;

export const LoaderWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 56px);
`;

export const Wrapper = styled.div`
  padding: 24px;
`;

export const Title = styled(typography.MediumTitleTypography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.grey600};
`;

export const InsightsWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const InsightsBoxWrapper = styled.div`
  display: flex;

  & > * + * {
    margin-inline-start: 20px;
  }
`;

export const InsightsBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1;
  padding: 25px 15px;
  border: 1px solid ${({ theme }) => theme.colors.grey001};
  border-radius: 8px;

  ${({ limitWidth }) =>
    limitWidth &&
    `
    width: 332.5px;
    margin: auto;
  `}
`;

export const InsightsInfoWrapper = styled.div``;

export const InsightsTitle = styled(typography.TitleOneBoldTypography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.black};
`;

export const InsightsSubTitle = styled(typography.TitleOneRegularTypography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.grey500};
`;

export const InsightsIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  color: ${({ color }) => color};
  background-color: ${({ backgroundColor }) => backgroundColor};
  border-radius: 50%;

  &:before {
    content: '\\e907';
    font-family: 'Icomoon';
    font-size: 20px;
  }
`;
